import { render, staticRenderFns } from "./Planner.vue?vue&type=template&id=b0c56e9e&scoped=true"
import script from "./Planner.vue?vue&type=script&lang=js"
export * from "./Planner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c56e9e",
  null
  
)

export default component.exports